import React, { Component } from 'react';

class Button extends Component{
    constructor(props){
        super(props);
    }
    render(){
        const { entryPointId, templateName, locale} = this.props;
        return(
            <button 
                className={this.props.classes}
                id={this.props.id}
                name={this.props.name}
                onClick={this.props.action && this.props.action!==''?(this.props.action):(null)}
                type={this.props.type && this.props.type!==""?(this.props.type):("button")}
                title={this.props.hoverTitle && this.props.hoverTitle!==''?(this.props.hoverTitle):(this.props.title)}
                area-label={this.props.areaLabel && this.props.areaLabel!==""?(this.props.areaLabel):(null)}
                data-testid={this.props.dataTestid && this.props.dataTestid!==""?(this.props.dataTestid):(null)}
                data-name={this.props.fname && this.props.fname!==""?(this.props.fname):(null)}
                data-mobile={this.props.mobile && this.props.mobile!==""?(this.props.mobile):(null)}
                data-contractno={this.props.contractno && this.props.contractno!==""?(this.props.contractno):(null)}
                data-chathistory={this.props.chathistory && this.props.chathistory!==""?(this.props.chathistory):(null)}
                data-lat={this.props.lat && this.props.lat!==""?(this.props.lat):(null)}
                data-lng={this.props.lng && this.props.lng!==""?(this.props.lng):(null)}
                data-value={this.props.dvalue && this.props.dvalue!==""?(this.props.dvalue):(null)}
                disabled={this.props.disabled && this.props.disabled!==''?(this.props.disabled):(null)}
                onMouseEnter={this.props.onMouseEnter && this.props.onMouseEnter!==''?(this.props.onMouseEnter):(null)}
                onMouseLeave={this.props.onMouseLeave && this.props.onMouseLeave!==''?(this.props.onMouseLeave):(null)}
                onTouchStart={this.props.onTouchEnd && this.props.onTouchEnd!==''?(this.props.onTouchEnd):(null)}
                data-entryPointId={entryPointId || ''}
                data-templateName={templateName || ''}
                data-locale={locale || ''}
            >
                {this.props.svg && this.props.svg==='true'?(
                    this.props.children
                ):(
                    this.props.title
                )}
                
            </button>        
        )
    }
}
Button.propTypes = {
    classes: React.propTypes.node,
    id: React.propTypes.node,
    name: React.propTypes.node,
    action: React.propTypes.node,
    type: React.propTypes.node,
    title: React.propTypes.node,
    hoverTitle: React.propTypes.node,
    areaLabel: React.propTypes.node,
    disabled: React.propTypes.node,
    dataTestid: React.propTypes.node,
    fname: React.propTypes.node,
    mobile: React.propTypes.node,
    contractno: React.propTypes.node,
    chathistory: React.propTypes.node,
    svg: React.propTypes.node,
    children: React.propTypes.node,
    lat: React.propTypes.node,
    lng: React.propTypes.node,
    onMouseEnter: React.propTypes.node,
    onMouseLeave: React.propTypes.node,
}
export default Button;